<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-equities page-operative-data-analysis-equities-new">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo equity</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.data-analysis.equity' }">Torna alla lista</app-router-link>
      </div>

      <FormEquity v-if="company && userCanEdit" @saved="saveEquity" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-equities-new',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormEquity: () => import('../../../../components/Operative/Form/FormEquity'),
    AppRouterLink: () => import('../../../../components/Layout/AppRouterLink'),
  },
  methods: {
    saveEquity (equity) {
      this.$api.addEquity(this.company.id, equity)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.equity',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
};

</script>
